import { create } from "zustand";
import { findAnnouncement, type AnnouncementId } from "@brewbase/lib";

interface AnnouncementStore {
  /** Opened by hand ("What's new", or a ?announcement=<id> preview link). */
  openId: AnnouncementId | null;
  open: (id: AnnouncementId) => void;
  close: () => void;
}

// `?announcement=<id>` opens it without recording anything: for previewing
// and for linking someone to an announcement they missed.
function previewFromUrl(): AnnouncementId | null {
  if (typeof window === "undefined") return null;
  const id = new URLSearchParams(window.location.search).get("announcement");
  return id ? (findAnnouncement(id)?.id ?? null) : null;
}

export const useAnnouncementStore = create<AnnouncementStore>((set) => ({
  openId: previewFromUrl(),
  open: (id) => set({ openId: id }),
  close: () => set({ openId: null }),
}));
